import React from 'react'
let PropTypes = React.PropTypes
// NOTIFICACIONES
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'
import moment from 'moment'
moment.locale('es')
// API
import api from '../../apiClient/v1'
// Componentes
import { TablaRegiones } from './TablaRegiones.jsx'
import { Indicadores } from './Indicadores.jsx'
import { Aprobacion } from './Aprobacion.jsx'
import {
    ModalTrigger,
    ModalDetalle,
    ModalDetalleCliente
} from './Modales.jsx'

export class MantenedorResumenMensual extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            mes: this.props.meses[0]['value'],
            regionesAuditorias: [],
            totales: '',
            diferencia: ''
        }
        this.ajaxErrorHandler = (errorTitle)=>{
            return (err)=>{
                if(err.status==500)
                    return this.refs.notificator.error("Error crítico en el servidor", "Contáctese con el departamento de informática.", 4*1000);
                // en otro error, buscar el cuerpo del mensaje
                let msgs = _.values(err.data).join('. ')
                console.log(err)
                console.log(errorTitle, err.data)
                this.refs.notificator.error(errorTitle, msgs, 4*1000);
            }
        }
        this.buscarAuditorias = ()=>{
            let mes = this.state.mes
            api.auditoria.getResumenMes(mes)
                .then(auditoria=>{
                    this.setState({regionesAuditorias: auditoria.regiones})
                    this.setState({total: auditoria.totales})
                    this.setState({diferencia: auditoria.diferencia})
                    this.setState({totalFacturaAnterior: auditoria.totalFacturaAnteriorFormat})
                    this.setState({estadoCliente: auditoria.aprobacionCliente})
                    this.setState({estadoSEI: auditoria.aprobacionSEI})
                    this.setState({facturado: auditoria.facturado})
                })
        }
        this.onSelectMesChanged = (evt)=>{
            this.setState({
                mes: evt.target.value
            }, ()=>{
                this.buscarAuditorias()
            })
        }
        this.generarFacturaTxt= ()=>{
            let request = api.facturacionSaldo().generarSaldoAuditorias(this.state.mes)
            request
                .then(()=>this.refs.notificator.success("Proceso satisfactorio", "archivo txt de factura generado y enviado correctamente.", 4*1000)
                )
                .catch(this.ajaxErrorHandler('Generar factura'));
            return request
        }
        this.aprobacionCliente = (aprobacionCliente)=>{
            let request = api.aud().actualizarAprobacionFCV(aprobacionCliente, this.state.mes)
            request
                .then(()=>this.refs.notificator.success("Proceso satisfactorio", "Estado de aprobación actualizado", 4*1000)
                )
                .catch(this.ajaxErrorHandler('Aprobación auditorías'));
            return request
        }
        this.correoSEI =  ()=>{
            let request = api.facturacion(2).generarCorreoAud(this.state.mes)
            request
                .then(()=>this.refs.notificator.success("Proceso satisfactorio", "Se ha notificado su aprobación a SEI", 4*1000)
                )
                .catch(this.ajaxErrorHandler('Aprobacion auditorias'));
            return request
        }
    }
    componentWillMount(){
        this.buscarAuditorias()
    }
    render(){
        return (
            <div className={'container-fluid'}>
                <div className={'row'}>
                    <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                    <div className={'col-sm-2 form-group '}>
                        <label className="control-label" htmlFor="selectMes">Mes</label>
                        <select className="form-control"  name="selectMes"
                                ref={ref=>this.inputMes=ref}
                                value={this.state.mes}
                                onChange={this.onSelectMesChanged.bind(this)}>
                            >
                            {this.props.meses.map((mes, index)=>{
                                return <option key={index} value={mes['value']}>{`${mes['text']}`}</option>
                            })}
                        </select>
                    </div>
                    {this.props.permisos.facturar?
                        <BotonFacturar
                            generarFactura={this.generarFacturaTxt}
                            valorActual={this.state.total}
                            diferencia={this.state.diferencia}
                            totalFacturaAnterior={this.state.totalFacturaAnterior}
                        />
                        :
                        <BotonDetalles
                            generarCorreo={this.correoSEI}
                            valorActual={this.state.total}
                            diferencia={this.state.diferencia}
                            totalFacturaAnterior={this.state.totalFacturaAnterior}
                        />
                    }
                    <BotonExcel
                        mes={this.state.mes}
                    />
                </div>
                <div className="row">
                    <div className="col-md-9">
                        <TablaRegiones
                            mes={this.state.mes}
                            regiones={this.state.regionesAuditorias}
                        />
                    </div>
                    <div className="col-md-3">
                        <Indicadores
                            valorActual={this.state.total}
                            diferencia={this.state.diferencia}
                            totalFacturaAnterior={this.state.totalFacturaAnterior}
                        />
                    </div>
                </div>    
            </div>
        )
    }
}
MantenedorResumenMensual.propTypes = {
    meses: PropTypes.arrayOf(PropTypes.object),
    permisos: PropTypes.object.isRequired
}
const BotonFacturar = ({generarFactura, valorActual, diferencia, totalFacturaAnterior})=>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-md btn-primary pull-right" onClick={showModal}>
                Facturar
                {isVisible && <ModalDetalle
                    valorActual={valorActual}
                    diferencia={diferencia}
                    totalFacturaAnterior={totalFacturaAnterior}
                    hideModal={hideModal}
                    generarFactura={generarFactura}
                />}
            </button>
        }
    </ModalTrigger>
const BotonDetalles = ({generarCorreo, valorActual, diferencia, totalFacturaAnterior})=>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-md btn-primary pull-right" onClick={showModal}>
                <span className="glyphicon glyphicon-ok"></span>
                {'Aprobar Facturación'}
                {isVisible && <ModalDetalleCliente
                    valorActual={valorActual}
                    diferencia={diferencia}
                    totalFacturaAnterior={totalFacturaAnterior}
                    hideModal={hideModal}
                    generarCorreo={generarCorreo}
                />}
            </button>
        }
    </ModalTrigger>
const BotonExcel = ({mes})=>
    <a className={'btn btn-md btn-success pull-right'}
       href={`/auditorias/descargar-excel-regiones/?mes=${mes}`}>
        Datos Excel
    </a>


// WEBPACK FOOTER //
// ./frontEnd/auditorias/resumen-mensual/MantenedorResumenMensual.jsx